import sheets from '~c/common/sheets'

export const getGarmentTypeName = (garmentId) => {
  const garment = sheets.garments[garmentId]
  if (!garment) throw new Error('bad garmentId')
  return sheets.garmentTypes[garment.garmentTypeId].name
}
